var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "access-forbidden" },
    [
      _c("div", { staticClass: "access-forbidden__message" }, [
        _vm._v(" " + _vm._s(_vm.$t("forbiddenPage.message")) + " ")
      ]),
      _c(
        "pui-button",
        { attrs: { type: "button" }, on: { click: _vm.requestAccess } },
        [_vm._v(" " + _vm._s(_vm.$t("forbiddenPage.requestAccess")) + " ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }